import * as THREE from 'three'
import { ThreeComponet } from './types'
import vertexShader from './glsl/skyOctahedronShell.vs'
import fragmentShader from './glsl/skyOctahedronShell.fs'

interface SkyOctahedronShellUniforms {
  side: THREE.IUniform<number>
  time: THREE.IUniform<number>
  [uniform: string]: THREE.IUniform<any>
}

export default class SkyOctahedronShell extends ThreeComponet<SkyOctahedronShellUniforms> {
  constructor(side: 0 | 1 = 0) {
    super({
      side: {
        // type: 'f',
        value: side,
      },
      time: {
        // type: 'f',
        value: 0,
      },
    })
  }

  createObj(): THREE.Mesh {
    const geometry = new THREE.OctahedronGeometry(150, 20)
    const mesh = new THREE.Mesh(
      geometry,
      new THREE.RawShaderMaterial({
        uniforms: this.uniforms,
        vertexShader,
        fragmentShader,
        transparent: true,
        side: this.uniforms.side.value === 1 ? THREE.FrontSide : THREE.BackSide,
        depthWrite: false,
      })
    )
    mesh.position.set(0, -50, this.uniforms.side.value === 1 ? 0.1 : -0.1)
    return mesh
  }

  render(time: number): void {
    this.uniforms.time.value += time
  }
}
